import { useParams } from "react-router-dom";
import i18n from "@/i18n";
import { AuditCard } from "@/features/Audit/AuditCard";
import { TechnicalInfoCard } from "@/components/TechnicalInfoCard";
import { R1DocumentsEditCard } from "./edit_card";

const client = "r1";
const table_name = "r1_documents";

export const R1DocumentsEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <R1DocumentsEditCard
          id={Number(id)}
          client={client}
          table_name={table_name}
        />
        <TechnicalInfoCard
          id={Number(id)}
          table_name={table_name}
          client={client}
          include_tsf_id={false}
        />
        <AuditCard
          id={Number(id)}
          client={client}
          audit_table_name={table_name}
        />
      </div>
    </div>
  );
};
